import { Action } from 'redux';

export enum NavigationActions {
  NAVIGATE_FORWARD = 'NAVIGATE_FORWARD',
  NAVIGATE_BACKWARD = 'NAVIGATE_BACKWARD',
  NAVIGATE_TO = 'NAVIGATE_TO'
}

export const createNavigateForwardAction = (): Action => ({
  type: NavigationActions.NAVIGATE_FORWARD
});

export const createNavigateBackwardAction = (): Action => ({
  type: NavigationActions.NAVIGATE_BACKWARD
});

export interface NavigateToAction extends Action {
  url: string;
}

export const createNavigateToAction = (url: string): NavigateToAction => ({
  type: NavigationActions.NAVIGATE_TO,
  url
});
